// extracted by mini-css-extract-plugin
module.exports = {"ad_box":"ad_box-1v2Z_JSF","ad_fixed":"ad_fixed-1I8NM14a","ad":"ad-O62xlAmQ"};